export default (key: string) => {
    const nuxtApp = useNuxtApp()

    if (nuxtApp.payload.data[key] || nuxtApp.static?.data?.[key]) {
        return true
    }

    return false
}
